import { makeStyles } from '@material-ui/core/styles'
import {
    AtlasBlackNear,
    ColorBaseWhite,
    ColorEastBay,
    ColorBaseMulberryBlue,
    ColorBaseRichBlack,
    ColorBaseDarkRed,
    ColorButtonHover,
    FontWeightLightBold
} from 'assets/styles/variables'

export const useWritingStylesStyles = makeStyles(() => ({
    defaultTag: {
        marginLeft: 10,
        backgroundColor: '#E6E6E6',
        padding: '5px 10px',
        textAlign: 'center',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 400,
        color: ColorBaseRichBlack,
        marginRight: '2px'
    },
    /** AI page header with gradient bottom border (red → purple → blue). */
    header: {
        justifyContent: 'space-between',
        alignItems: 'center',
        maxHeight: '100px',
        padding: '24px',
        paddingBottom: '28px',
        backgroundColor: ColorBaseWhite,
        display: 'flex',
        position: 'relative',
        boxShadow: 'none',
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '1.5px',
            opacity: 0.8,
            background: 'linear-gradient(90deg, #be0c1e 0%, #ab48da 50%, #4069fe 100%)'
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            bottom: '-2px',
            left: 0,
            right: 0,
            height: '12px',
            opacity: 0.25,
            filter: 'blur(20px)',
            background:
                'linear-gradient(90deg, rgba(226,226,229,0) 0%, #be0c1e 15%, #ab48da 50%, #4069fe 85%, rgba(226,226,229,0) 100%)',
            pointerEvents: 'none'
        }
    },
    subHeaderText: {
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '32px'
    },
    /** Writing style detail page title — aligns with minutes editor title (`minutesHeaderTitle`). */
    detailPageTitle: {
        fontFamily: 'Source Sans Pro',
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '32px',
        color: '#282E37'
    },
    subTitleText: {
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px'
    },
    rootContainer: {
        borderRadius: '12px',
        padding: '16px',
        '& .hide-scrollbar': {
            overflowY: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    },
    showMoreBtn: {
        backgroundColor: 'white',
        color: ColorEastBay,
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        textTransform: 'none',
        border: `1px solid ${ColorEastBay}`,
        borderRadius: '8px',
        padding: '12px 24px',
        margin: '24px auto',
        display: 'block',
        '&:hover': {
            backgroundColor: ColorEastBay,
            color: 'white'
        }
    },
    showMoreBtnLoading: {
        backgroundColor: 'white',
        color: ColorEastBay,
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        textTransform: 'none',
        border: `1px solid ${ColorEastBay}`,
        borderRadius: '8px',
        padding: '12px 24px',
        margin: '24px auto',
        display: 'block'
    },
    noDataContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 0',
        textAlign: 'center'
    },
    noDataTitle: {
        fontSize: '20px',
        fontWeight: 600,
        color: AtlasBlackNear,
        marginTop: '24px',
        marginBottom: '16px'
    },
    menuItemIcon: {
        paddingRight: '16px'
    },
    allStylesText: {
        color: ColorBaseRichBlack,
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontFamily: 'Source Sans Pro',
        fontSize: 18,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '24px',
        margin: '24px 0px',
        paddingLeft: '24px'
    },
    writingStyleContainer: {
        marginBottom: '10px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        background: ColorBaseWhite,
        display: 'flex',
        alignItems: 'center',
        padding: '8px 16px'
    },
    boxContainer: {
        display: 'flex',
        alignItems: 'center',
        flex: 1
    },
    styleIconAlignment: {
        display: 'inline-flex',
        alignItems: 'center',
        height: 50,
        width: 50,
        minWidth: 50,
        minHeight: 50
    },
    defaultStyle: {
        fontWeight: 600,
        fontSize: 18
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    defaultStyleBox: {
        flex: 1
    },
    defaultStyleDescription: {
        fontSize: 14,
        color: '#666',
        marginTop: 4
    },
    preferredTagContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    menuOptionsAlignment: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '20px',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    /** Primary Save — matches minutes `StatusPopoverButton` / Draft (East Bay fill, 40px). */
    generateStyleButton: {
        textTransform: 'none',
        backgroundColor: ColorEastBay,
        color: ColorBaseWhite,
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '20px',
        padding: '8px 12px',
        borderRadius: '2px',
        minWidth: '99px',
        height: '40px',
        '&:hover': {
            backgroundColor: ColorButtonHover
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`
        },
        '&:disabled': {
            backgroundColor: '#E6E6E6',
            color: '#666666',
            cursor: 'not-allowed'
        },
        '& .MuiButton-startIcon': {
            color: ColorBaseWhite
        },
        '&:disabled .MuiButton-startIcon': {
            color: '#666666'
        }
    },
    viewButton: {
        textTransform: 'none',
        backgroundColor: 'transparent',
        color: '#465A7C',
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 600,
        padding: '8px 16px',
        borderRadius: '2px',
        border: '1px solid #465A7C',
        minWidth: '80px',
        height: '36px',
        '&:hover': {
            backgroundColor: '#F5F5F5',
            borderColor: ColorButtonHover,
            color: ColorButtonHover
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`
        }
    },
    detailToolbarTextButton: {
        textTransform: 'none',
        backgroundColor: ColorBaseWhite,
        color: ColorEastBay,
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: FontWeightLightBold,
        lineHeight: '20px',
        padding: '8px 12px',
        borderRadius: '2px',
        border: `1px solid ${ColorEastBay}`,
        minWidth: 'auto',
        height: '40px',
        '&:hover': {
            backgroundColor: '#F5F5F5'
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
            color: 'rgba(0, 0, 0, 0.26)',
            backgroundColor: '#fafafa'
        }
    },
    detailHeaderTitleBox: {
        flex: 1
    },
    /** Matches UtilityIconBar `backButton` (MM-BackToMinutesManager): 40×40 hit target, East Bay arrow icon */
    detailBackButton: {
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
        marginRight: '8px',
        minWidth: '40px',
        width: '40px',
        height: '40px',
        padding: 0,
        backgroundColor: 'transparent',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:focus, &:active': {
            outline: 'none',
            minWidth: '40px',
            width: '40px',
            height: '40px',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    },
    detailRegenerateSpacing: {
        marginRight: 16
    },
    detailContentArea: {
        marginTop: '32px',
        '& > div > div': {
            maxHeight: 'calc(100vh - 220px)',
            '@media (min-width: 768px) and (max-width: 1180px)': {
                maxHeight: 'calc(100vh - 300px)'
            }
        }
    },
    detailSourceLabel: {
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        color: '#666',
        marginBottom: 4
    },
    detailDateLabel: {
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        color: '#666',
        marginBottom: 20
    },
    detailSectionNavLabel: {
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#666666',
        marginBottom: 12
    },
    detailStyleDescriptionHeading: {
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
        marginTop: 0,
        marginBottom: 8
    },
    detailLoadError: {
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        marginBottom: 16
    },
    detailSaveError: {
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        fontWeight: 400,
        color: ColorBaseDarkRed
    },
    counterRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginTop: 8
    },
    errorStack: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: 4,
        flex: 1
    },
    detailSaveErrorRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    },
    detailSaveWarningRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    },
    detailRegenerateIcon: {
        width: 18,
        height: 18,
        color: ColorEastBay,
        flexShrink: 0,
        '& path': {
            fill: 'currentColor'
        }
    },
    detailSaveIcon: {
        fill: 'currentColor',
        width: 18,
        height: 18
    },
    viewModalContainer: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 200px)',
        maxWidth: '900px',
        maxHeight: 'calc(100vh - 100px)',
        backgroundColor: ColorBaseWhite,
        zIndex: 9999,
        boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.16)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column' as const,
        overflow: 'hidden'
    },
    viewModalHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px'
    },
    viewModalTitle: {
        fontFamily: 'Source Sans Pro',
        fontSize: '22px',
        fontWeight: 600,
        lineHeight: '26px',
        color: ColorBaseRichBlack
    },
    viewModalCloseButton: {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        padding: '8px',
        minWidth: 'auto',
        '&:hover': {
            backgroundColor: 'rgba(148, 148, 148, 0.16)'
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    },
    viewModalDivider: {
        height: '1px',
        background: '#E6E6E6',
        width: '100%'
    },
    viewModalBody: {
        flex: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column' as const
    },
    viewModalContent: {
        padding: '20px',
        flex: 1,
        overflowY: 'auto' as const,
        maxHeight: '300px',
        '&::-webkit-scrollbar': {
            width: '6px',
            backgroundColor: 'rgba(0, 0, 0, 0.02)'
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0, 0, 0, 0.5)',
            borderRadius: '4px'
        }
    },
    viewModalText: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '20px',
        color: '#333',
        textAlign: 'justify' as const
    },
    viewModalFooter: {
        borderTop: '2px solid #e6e6e6',
        borderBottom: '2px solid #e6e6e6',
        fontFamily: 'Source Sans Pro',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        padding: '8px 24px',
        height: '34px',
        background: '#F5F8F9',
        display: 'flex',
        alignItems: 'center'
    },
    modalContainer: {
        position: 'fixed',
        top: '90px',
        left: '90px',
        right: '90px',
        bottom: '90px',
        backgroundColor: ColorBaseWhite,
        zIndex: 9999,
        overflow: 'auto',
        boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.16)',
        borderRadius: '8px'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px',
        borderBottom: '1px solid #E6E6E6'
    },
    modalTitle: {
        fontFamily: 'Source Sans Pro',
        fontSize: '24px',
        fontWeight: 600,
        color: ColorBaseRichBlack
    },
    modalCloseButton: {
        minWidth: 'auto',
        padding: '8px'
    },
    modalBody: {
        padding: '24px'
    },
    modalSectionTitle: {
        fontFamily: 'Source Sans Pro',
        fontSize: '18px',
        fontWeight: 600,
        color: ColorBaseRichBlack,
        marginBottom: '16px',
        paddingLeft: '20px'
    },
    modalContentBox: {
        backgroundColor: '#F5F5F5',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
    },
    modalFieldLabel: {
        fontFamily: 'Source Sans Pro',
        fontSize: '14px',
        fontWeight: 600,
        color: '#666',
        marginBottom: '8px'
    },
    modalFieldValue: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        color: ColorBaseRichBlack,
        marginBottom: '16px'
    },
    modalGeneratedStyleValue: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        color: ColorBaseRichBlack,
        lineHeight: '24px'
    },
    detailContentWrapper: {
        padding: '24px 24px 40px 24px',
        fontFamily: 'Source Sans Pro',
        position: 'relative'
    },
    detailPromptFieldWrapperRegenerating: {
        cursor: 'not-allowed',
        position: 'relative'
    },
    detailTextFieldInputRootRegenerating: {
        pointerEvents: 'none'
    },
    /** Centered spinner overlay — sits on top of the disabled textarea during regeneration. */
    regeneratingSpinnerOverlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2,
        borderRadius: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.55)'
    },
    savingOverlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        borderRadius: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.82)'
    },
    savingOverlayInner: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        gap: '16px'
    },
    savingOverlayLabel: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 600,
        color: '#37465B'
    },
    highlightSpelling: {
        borderBottom: '2px dotted #DC2626'
    },
    highlightSecurity: {
        backgroundColor: '#FFE0E0',
        borderBottom: '2px solid #DC2626',
        borderRadius: '2px'
    },
    detailSaveWarning: {
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        fontWeight: 400,
        color: '#92400E'
    },

    // ─── HighlightedTextarea ──────────────────────────────────────────────────

    htWrapper: {
        position: 'relative',
        borderRadius: '8px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.06)',
        backgroundColor: ColorBaseWhite,
        cursor: 'text',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        '&:hover': { borderColor: 'rgba(69, 93, 130, 0.45)' },
        '&:focus-within': {
            borderColor: ColorBaseRichBlack,
            boxShadow: `0px 0px 0px 2px ${ColorBaseMulberryBlue}`
        }
    },
    htWrapperDisabled: {
        border: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        cursor: 'not-allowed',
        // Suppress hover feedback — the field is not interactive
        '&:hover': { borderColor: 'rgba(0, 0, 0, 0.12)' }
    },
    htSharedLayout: {
        fontFamily: '"Source Sans Pro", "Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: 400,
        padding: '12px 18px',
        margin: 0,
        boxSizing: 'border-box',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    },
    htMirror: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'scroll',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none' as const,
        borderRadius: '8px',
        pointerEvents: 'none',
        zIndex: 0,
        // All mirror text is transparent — only <mark> backgrounds are visible
        color: 'transparent',
        '&::after': {
            content: '"\\200B"'
        }
    },
    htTextarea: {
        position: 'relative',
        zIndex: 1,
        display: 'block',
        width: '100%',
        height: 'calc(100vh - 380px)',
        minHeight: '250px',
        resize: 'none',
        border: 'none',
        outline: 'none',
        borderRadius: '8px',
        background: 'transparent',
        color: ColorBaseRichBlack,
        caretColor: 'rgba(0, 0, 0, 0.87)',
        overflowY: 'auto',
        scrollbarGutter: 'stable',
        overscrollBehaviorY: 'none',
        cursor: 'text',
        '@media (min-width: 768px) and (max-width: 1180px)': {
            height: 'calc(100vh - 415px)'
        },
    },
    htTextareaDisabled: {
        color: 'rgba(0, 0, 0, 0.38)',
        cursor: 'not-allowed',
        pointerEvents: 'none',
        userSelect: 'none'
    },
    htMarkSpelling: {
        textDecoration: 'underline dotted',
        textDecorationColor: '#DC2626',
        backgroundColor: 'transparent',
        color: 'transparent'
    },
    htMarkSecurity: {
        backgroundColor: '#FFE0E0',
        borderBottom: '2px solid #DC2626',
        borderRadius: '2px',
        color: 'transparent'
    },
    htMarkProfanity: {
        backgroundColor: '#FFF3CD',
        borderRadius: '2px',
        color: 'transparent'
    }
}))
